import React from "react";
import { Avatar, Box, Card, CardContent, CardHeader, Chip, Divider, Stack, Typography } from "@mui/material";

function statusColor(status) {
    const s = String(status || "").toLowerCase();
    if (s === "done") return "success";
    if (s === "canceled" || s === "cancelled") return "error";
    return "info";
}

function getUserInitial(user) {
    if (!user) return "?";
    const first = String(user.first_name || "").trim()[0];
    const last = String(user.last_name || "").trim()[0];
    return (first || last || "?").toUpperCase();
}

export default function ClassroomInfoCard({ classroom }) {
    const teacher = classroom?.teacher || null;
    const teacherName = teacher ? `${teacher.first_name || ""} ${teacher.last_name || ""}`.trim() : "";
    const classroomTitle = classroom?.name || `Classroom #${classroom?.id || "—"}`;

    return (
        <Card variant="outlined" sx={{ height: "100%", minWidth: 0 }}>
            <CardHeader title={classroomTitle} />
            <Divider />
            <CardContent sx={{ pt: 2 }}>
                <Box sx={{ display: "flex", alignItems: "flex-start", gap: 2, pb: 2 }}>
                    {teacher?.avatar ? (
                        <Avatar src={teacher.avatar} alt={teacherName || "Teacher"} sx={{ width: 88, height: 88, flexShrink: 0 }} />
                    ) : (
                        <Avatar sx={{ width: 88, height: 88, flexShrink: 0, fontSize: "1.75rem", fontWeight: 600 }}>
                            {getUserInitial(teacher)}
                        </Avatar>
                    )}
                    <Box sx={{ minWidth: 0, flex: 1, pt: 0.25 }}>
                        <Typography variant="h6" sx={{ fontWeight: 600, lineHeight: 1.3 }}>
                            {teacherName || "No teacher assigned"}
                        </Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, wordBreak: "break-word" }}>
                            {teacher?.email || "—"}
                        </Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>
                            {teacher?.phone || "—"}
                        </Typography>
                    </Box>
                </Box>
                <Divider sx={{ my: 1 }} />
                <Stack spacing={1}>
                    <Typography><Typography component="span" color="text.secondary" sx={{ minWidth: 140, display: "inline-block" }}>ID</Typography><Typography component="span" sx={{ fontWeight: 600 }}>{classroom?.id || "—"}</Typography></Typography>
                    <Typography>
                        <Typography component="span" color="text.secondary" sx={{ minWidth: 140, display: "inline-block" }}>Status</Typography>
                        {classroom?.status ? <Chip label={classroom.status} size="small" color={statusColor(classroom.status)} /> : "—"}
                    </Typography>
                    <Typography><Typography component="span" color="text.secondary" sx={{ minWidth: 140, display: "inline-block" }}>Start / end</Typography>{classroom?.start_date || "—"} → {classroom?.end_date || "—"}</Typography>
                    <Typography><Typography component="span" color="text.secondary" sx={{ minWidth: 140, display: "inline-block" }}>Students (count)</Typography>{classroom?.students ?? "—"}</Typography>
                    <Typography><Typography component="span" color="text.secondary" sx={{ minWidth: 140, display: "inline-block" }}>Lessons (count)</Typography>{classroom?.lessons ?? "—"}</Typography>
                </Stack>
            </CardContent>
        </Card>
    );
}

